import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Truck, Store } from "lucide-react";
import { fmtDateTime } from "@/lib/format";
import { DateTimePicker } from "@/components/DateTimePicker";

const Opt = ({ active, onClick, icon: Icon, label, testId }) => (
  <button type="button" onClick={onClick} data-testid={testId}
    className={`flex-1 flex items-center justify-center gap-1.5 h-9 rounded-md border text-sm transition-colors ${active ? "border-primary bg-primary/10 text-primary font-medium" : "border-border text-muted-foreground hover:bg-muted"}`}>
    <Icon className="h-4 w-4" />{label}
  </button>
);

// Pickup / delivery choice captured at prescription upload; prefilled into POS on "Send to POS".
export function RxDeliveryFields({ form, setForm }) {
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const delivery = form.fulfillment === "delivery";
  return (
    <div className="space-y-2 rounded-md border border-border p-3" data-testid="rx-fulfillment">
      <Label>How will the patient get it?</Label>
      <div className="flex gap-2">
        <Opt active={!delivery} onClick={() => setForm((f) => ({ ...f, fulfillment: "pickup" }))} icon={Store} label="Pickup" testId="rx-fulfillment-pickup" />
        <Opt active={delivery} onClick={() => setForm((f) => ({ ...f, fulfillment: "delivery" }))} icon={Truck} label="Delivery" testId="rx-fulfillment-delivery" />
      </div>
      {delivery && (
        <div className="space-y-2 pt-1">
          <div><Label className="text-xs">Delivery address *</Label><Input value={form.delivery_address} onChange={set("delivery_address")} placeholder="House no., street, area, landmark" data-testid="rx-delivery-address" /></div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
            <div><Label className="text-xs">Contact phone</Label><Input value={form.delivery_phone} onChange={set("delivery_phone")} placeholder="024…" data-testid="rx-delivery-phone" /></div>
            <div><Label className="text-xs">Deliver at</Label><DateTimePicker value={form.delivery_scheduled_for} onChange={(v) => setForm((f) => ({ ...f, delivery_scheduled_for: v }))} testId="rx-delivery-schedule" /></div>
            <div><Label className="text-xs">Delivery fee (GHS)</Label><Input type="number" min={0} step="0.01" value={form.delivery_fee} onChange={set("delivery_fee")} placeholder="0.00" data-testid="rx-delivery-fee" /></div>
          </div>
        </div>
      )}
    </div>
  );
}

export function RxDeliverySummary({ rx }) {
  if (!rx?.fulfillment) return null;
  if (rx.fulfillment === "pickup") return <div className="text-xs text-muted-foreground flex items-center gap-1.5" data-testid="rx-delivery-summary"><Store className="h-3.5 w-3.5" /> Patient will pick up</div>;
  return (
    <div className="text-xs flex items-start gap-1.5" data-testid="rx-delivery-summary">
      <Truck className="h-3.5 w-3.5 mt-0.5 text-primary" />
      <span>Deliver to <b>{rx.delivery_address}</b>{rx.delivery_phone ? ` · ${rx.delivery_phone}` : ""}{rx.delivery_scheduled_for ? ` · ${fmtDateTime(rx.delivery_scheduled_for)}` : ""}</span>
    </div>
  );
}
